/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { BoxView } from '@components/atoms'
import { BoxTab, TabType, TabPanelView } from '@components/molecules'

interface PropsType {
	tabList: TabType[]
	tabIndex?: number
	onTabChange?: (index: number) => void
	backgroundColor?: string
	rightHeaderAccessory?: React.ReactNode
}

interface PanelPropsType {
	tabList: TabType[]
	tabIndx: number
}

const RenderTabPanels = (props: PanelPropsType) => {
	return (
		<>
			{props.tabList.map((aTab: TabType) => (
				<TabPanelView key={aTab.id} index={aTab.index} value={props.tabIndx}>
					{aTab.panel ? aTab.panel : <>{aTab.index}</>}
				</TabPanelView>
			))}
		</>
	)
}

const TabPanels = React.memo(RenderTabPanels) as typeof RenderTabPanels

export const TabBoxView = (props: PropsType) => {
	// state
	const [tabIndx, setTabIndex] = React.useState(0)

	const onIndexChange = (index: number) => {
		if (props.onTabChange) {
			props.onTabChange(index)
		} else {
			setTabIndex(index)
		}
	}

	const Title = () => (
		<BoxTab
			tabList={props.tabList}
			tabIndex={props.tabIndex ?? tabIndx}
			onIndexChange={onIndexChange}
		/>
	)

	return (
		<BoxView
			css={style}
			title="사용자"
			className="tabBoxView-boxView"
			backgroundColor={props.backgroundColor}
			renderTitle={<Title />}
			rightHeaderAccessory={props.rightHeaderAccessory}
		>
			<TabPanels tabIndx={props.tabIndex ?? tabIndx} tabList={props.tabList} />
		</BoxView>
	)
}

const style = css({
	width: '100%',
	minWidth: '10rem',
	marginRight: '0.5rem',
})
